import { useCCFeatureFlagsContext } from '@contexts/CCFeatureFlagContext';
import type { CC_FEATURE_FLAGS } from 'types/layout';

export const useFF = (ff: CC_FEATURE_FLAGS) => {
	const { hasFeature } = useCCFeatureFlagsContext();

	return hasFeature(ff);
};
